const Home = () => (
  <div>
    <h2>Introduction</h2>
    <p>
      Hi, my name is Zinnie Zhang and welcome to my personal corner of the internet. I'm currently based in Boston, drawing inspiration from its
      intellectual atmosphere as a 1L/2L at Harvard Law School. Originally
      from Fuzhou, China, I grew up in the harsh winters of Toronto, Canada and have spent the past 8 years in the US living in most of its major cities. 
      Places that have my heart include San Francisco, New York City, Nashville (where I did my undergrad), and Bogotá, Colombia.
    </p>
    <p>
      I love company-building. I previously scaled a venture-backed startup to 6 figures. We didn't hit product-market fit so I returned capital to my first believers. I'm actively looking for co-founders for my second big swing. 
    </p>

    <p>
      In my free time, I enjoy going to coffee shops and Soulcycle.
    </p>

    <div>
      <h2>Follow along</h2>
      <ul>
        <li>
          <a href="https://www.linkedin.com/in/zinniezhang">LinkedIn</a>
          <p style={{ display: "inline" }}>
            {" "}
            - for startup related stuff.{" "}
          </p>
        </li>
        <li>
          <a href="https://www.instagram.com/zinniezhang">Instagram</a>
          <p style={{ display: "inline" }}>
            {" "}
            - for the occasional ragebait reel.{" "}
          </p>
        </li>
        <li>
          <a href="https://x.com/zinniezhang">X</a>
          <p style={{ display: "inline" }}>
            {" "}
            - for more unhinged thoughts.{" "}
          </p>
        </li>
      </ul>
      <h2>Get in touch</h2>
      <p style={{ margin: 0 }}>
        Personal: zinnie.zhang@gmail.com
        <br />
        Business: xzhang@jd29.law.harvard.edu
      </p>
    </div>
  </div>
);

export default Home;
